var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Map',{ref:"map",attrs:{"show-donation-ad":_vm.showDonationAd}})
}
var staticRenderFns = []

export { render, staticRenderFns }